<template>
    <div class="absolute w-320 pt-4 z-100">
        <ul
            class="rounded h-full max-h-320 overflow-y-auto overflow-x-hidden scroll-styled bg-white border border-primary"
            ref="dropdownList"
        >
            <li
                v-for="(option, index) in options"
                :key="index"
                class="px-16 py-8 first-letter:uppercase flex justify-between items-center cursor-pointer text-black hover:bg-primary hover:text-white"
                @mouseover="handleHover(index)"
                @click.stop="handleClick(option)"
                @selected-item="$emit('selected-item', $event)"
                ref="listItems"
            >
                <span>{{ option.label }}</span>
                <svg-icon v-if="option.children.length" type="keyboard-arrow-right"></svg-icon>
                <multi-level-dropdown-child
                    v-if="option.children.length && index === hover"
                    :options="option.children"
                    :style="childPosition"
                    class="left-full ml-4"
                    @selected-item="$emit('selected-item', $event)"
                />
            </li>
        </ul>
    </div>
</template>

<script>
import SvgIcon from "../../components/ui/SvgIcon";

export default {
    name: "MultiLevelDropdownChild",
    components: {SvgIcon},
    props: {
        options: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            hover: false,
            childPosition: {},
        };
    },
    methods: {
        handleClick(option) {
            if (option.children.length) {
                return;
            }
            this.$emit('selected-item', option);
        },
        isChildDropdown() {
            return this.$parent.$options.name === 'MultiLevelDropdownChild';
        },
        handleHover(index) {
            this.hover = index;

            if (this.$refs.listItems && this.$refs.listItems[index]) {
                const parentItem = this.$refs.listItems[index];
                const parentRect = parentItem.getBoundingClientRect();
                const listRect = this.$refs.dropdownList.getBoundingClientRect();

                // Calculate the top position relative to the parent list item
                let topOffset = parentRect.top - listRect.top;

                this.childPosition = {
                    top: `${topOffset}px`
                };
            }
        }
    },
}
</script>